import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationControlTest = createCrudVuexModule({
  namespaced: true,
  path: "/audit-control/control-test",
  moduleName: "organizationControlTest",
  options: {
    localizedFields: ["name", "description", "testType", "note", "population", "sampleSize"],
  },
  actions: {},
});
